import callApi, { CallApiResult } from 'src/api';
import { SCHEMA_FEEDBACK_SHAPE } from 'src/schemas/MyData';

/* Customer Feedback */

export const fetchCustomerFeedback = (): Promise<CallApiResult> => {
    const endpoint = '/api/customerFeedback/current';
    return callApi(endpoint);
};

export const submitCustomerFeedback = (data: SCHEMA_FEEDBACK_SHAPE): Promise<CallApiResult> => {
    return callApi('/api/customerFeedback/current', { method: 'POST', data });
};
